<template>
  <div class="my-5" :class="col ? `col-lg-${col}` : ''">
    <!-- ========== Start:: Date Picker Input ========== -->
    <div class="input_wrapper top_label" v-if="type === 'date'">
      <label class="form-label">
        {{ placeholder }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <a-date-picker
        dir="rtl"
        placeholder=""
        format="YYYY-MM-DD"
        valueFormat="YYYY-MM-DD"
        :value="value"
        :disabled-date="disabledDate"
        @change="updateValue($event)"
        :readonly="readonly"
        :disabled="disabled"
      />
    </div>
    <!-- ========== End:: Date Picker Input ========== -->
    <!-- ========== Start:: Time Picker Input ========== -->
    <div class="input_wrapper top_label" v-if="type === 'time'">
      <label class="form-label">
        {{ placeholder }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <a-time-picker
        placeholder=""
        format="HH:mm"
        valueFormat="HH:mm"
        :value="value"
        @change="updateValue($event)"
        @open-change="onOpenChange"
        :readonly="readonly"
        :disabled="disabled"
        :disabled-hours="computeDisabledHours"
        :disabled-minutes="computeDisabledMinutes"
        class="w-100"
      />
    </div>
    <!-- ========== End:: Time Picker Input ========== -->
  </div>
</template>

<script>
export default {
  name: "BasePickerInput",
  data() {
    return {
      selectedHour: null,
    };
  },
  props: {
    // ====== Start:: General Inputs Props ====== //
    col: {
      required: false,
      type: String,
    },
    value: {
      required: true,
    },
    disabledDate: {
      required: false,
    },
    type: {
      required: true,
      type: String,
      validator: (value) => ["date", "time"].includes(value),
    },
    placeholder: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    allowedTimes: {
      required: false,
      type: Array, // Array of allowed time strings like ["00:00", "00:15", ...]
      default: () => [],
    },
    minuteStep: {
      type: Number,
      default: 5, // default step: every 5 minutes
    },
    // ====== End:: General Inputs Props ====== //
  },

  // mounted() {
  //   if (this.type === "time" && !this.value) {
  //     this.updateValue("12:00");
  //   }
  // },
  methods: {
    updateValue(e) {
      this.$emit("input", e);

      // Also extract selected hour when time changes
      if (typeof e === "string" && e.includes(":")) {
        const hour = parseInt(e.split(":")[0]);
        this.selectedHour = hour;
      }
    },

    onOpenChange(open) {
      if (!open) {
        this.selectedHour = null;
      } else if (typeof this.value === "string") {
        const hour = parseInt(this.value.split(":")[0]);
        this.selectedHour = isNaN(hour) ? null : hour;
      }
    },

    computeDisabledHours() {
      if (!this.allowedTimes.length) return [];

      const allHours = Array.from({ length: 24 }, (_, i) => i);
      const allowedHours = [
        ...new Set(
          this.allowedTimes.map((time) => parseInt(time.split(":")[0]))
        ),
      ];

      return allHours.filter((h) => !allowedHours.includes(h));
    },
    computeDisabledMinutes(hour) {
      if (!this.allowedTimes.length || hour === null) return [];

      const hourStr = String(hour).padStart(2, "0");
      const allowedMinutes = this.allowedTimes
        .filter((time) => time.startsWith(`${hourStr}:`))
        .map((time) => parseInt(time.split(":")[1]));

      const allMinutes = Array.from({ length: 60 }, (_, i) => i);
      return allMinutes.filter((min) => !allowedMinutes.includes(min));
    },
  },
};
</script>

<style>
/* Hide disabled (grayed out) minute options */
li.ant-time-picker-panel-select-option-disabled {
  display: none !important;
}
</style>
